// Crédito grupal: mismas reglas que valida el backend (integrantes_solicitud.py).
export const ROL_LABEL = { titular: "Titular", obligado_solidario: "Obligado solidario" };

export const filaVacia = (rol = "obligado_solidario") =>
  ({ cliente_id: "", cliente: "", rfc: "", rol, monto: "", tasa_ordinaria: "" });

export const sumaMontos = (its) =>
  Math.round((its || []).reduce((s, it) => s + (parseFloat(it.monto) || 0), 0) * 100) / 100;

export function erroresGrupo(its) {
  const lista = its || [];
  const ids = lista.map((i) => i.cliente_id).filter(Boolean);
  const errs = [];
  if (lista.length < 2) errs.push("mínimo 2 integrantes");
  if (lista.filter((i) => i.rol === "titular").length !== 1) errs.push("exactamente 1 titular");
  if (ids.length !== lista.length) errs.push("cliente en cada integrante");
  else if (new Set(ids).size !== ids.length) errs.push("sin clientes repetidos");
  if (lista.some((i) => !(parseFloat(i.monto) > 0))) errs.push("monto mayor a $0 en cada uno");
  return errs;
}
